module.exports = __webpack_public_path__ + "static/montserrat-v12-latin-700-79982cd1f74c6fa7451bf9b37ead09ff.woff2";